<template>
  <div class="content has-text-centered">
    <div class="bg"></div>
    <div id="verifyEmailFormContainer" class="columns is-vcentered">
      <div class="column is-6 is-offset-3">
        <div class="box">
          <img src="../../assets/img/eurotrader_logo_rgb_purple.svg" />
          <br />
          <br />
          <div class="box-text" v-if="activeMessage === 'already-verified'">
            {{$t("your_email_is_verified")}}
            <p>
              <router-link :to="'/' + Language + '/login'">{{$t("click_here_to_login")}}</router-link>
            </p>
          </div>
          <div class="box-text" v-if="activeMessage === 'success'">
            {{$t("success_email_verified")}}
            <p>
              <router-link :to="'/' + Language + '/login'">{{$t("click_here_to_login")}}</router-link>
            </p>
          </div>
          <div class="box-text" v-if="activeMessage === 'expired'">
            {{$t("your_link_expired")}}
            <p>
              <a @click="requestEmailVerification"> {{$t("click_here_to_request_verification_email")}}</a>
            </p>
          </div>
          <div
            class="box-text"
            v-if="activeMessage === 'new-verification-email-success'"
          >{{$t("a_new_verification_link_send")}}</div>
          <div
            class="box-text"
            v-if="activeMessage === 'server-error'"
          >{{$t("error_contact_support")}}</div>
          <div
            class="box-text"
            v-if="activeMessage === 'invalid-request'"
          >{{$t("invalid_request_please_check_your_link")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../../app'
import config from '../../config'
import { mapGetters, mapActions } from 'vuex'

export default {
  data() {
    return {
      activeMessage: '',
    }
  },
  computed: {
    websiteURL() {
      return config.URL.website
    },
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    this.$bus.$emit('ChangeHeadings', 'Email Verification', null)

    if (!this.checkQuery()) {
      return false
    }

    service
      .post('/email/verify', {
        email: this.$route.query.e,
        verification_code: this.$route.query.c,
      })
      .then(response => {
        if (response.data.already_verified) {
          this.activeMessage = 'already-verified'
          return
        }
        this.activeMessage = 'success'
      })
      .catch(error => {
        if (error.response.data.meta) {
          if (error.response.data.meta.expired) {
            this.activeMessage = 'expired'
            return
          }
        }
        this.activeMessage = 'invalid-request'
      })
  },
  methods: {
    checkQuery() {
      if (Object.keys(this.$route.query).length <= 0) {
        this.$toasted.error(this.$t('invalid_verification_code'), { duration: 10000 })
        return false
      }

      if (this.$route.query.e === undefined) {
        this.$toasted.error(this.$t('invalid_verification_code'), { duration: 10000 })
        return false
      }
      if (this.$route.query.c === undefined) {
        this.$toasted.error(this.$t('invalid_verification_code'), { duration: 10000 })
        return false
      }
      return true
    },
    requestEmailVerification() {
      if (!this.checkQuery()) {
        return false
      }

      service
        .post('/email/request-email-verification', {
          email: this.$route.query.e,
        })
        .then(response => {
          this.activeMessage = 'new-verification-email-success'
        })
        .catch(() => {
          this.activeMessage = 'server-error'
        })
    },
    ...mapActions(['logoLoader/set']),
  },

  filters: {
    json: function(value) {
      return value
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

.bg {
  width: 100%;
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  z-index: -1;
  background-image: url('../../assets/img/bg-et-clientarea1.png');
  background-size: cover;
}

#verifyEmailFormContainer {
  margin-top: calc(33vh - 225px);
}
.box {
  padding: 50px 40px;
  box-shadow: 5px 5px 20px #0000001A;
  border-radius: 0px 0px 30px 0px;
  background-color: #F7F6FD;
  width: 660px;
  margin-top: 14%;
  div#message {
    color: #ccc;
    margin-bottom: 20px;
  }
  > img {
    width: 295px;
  }
  h1 {
    color: #fff;
    font-weight: 700;
    margin: 40px 0;
    font-size: 24px;
  }
  .box-text{
    color: #10182A;
    font-size: 16px;
    line-height: 24px;
    font-family: $family-primary;
    font-size: 16px;
    line-height: 24px;
    font-weight: 300;
    a{
      color: #6826F4;
      font-weight: 700;
      text-decoration: none;
    }
  }
  form {
    h4 {
      color: #fff;
      font-size: 18px;
    }
    a:hover {
      color: #fff;
    }
    a.verifyEmail {
      float: left;
      margin: -10px 0 20px;
      font-size: 14px;
    }
    label {
      text-align: left;
      font-size: 14px;
      color: #fff;
    }
    .columns.regButtons {
      margin-bottom: -10px;
    }
    .button.login,
    .button.reg {
      font-family: $family-condensed;
      font-weight: 700;
      width: 100%;
      &.is-black {
        background-color: #000;
        border: 1px solid #f0f0f0;
      }
    }
    .select.lang {
      select {
        background-color: transparent;
        color: $primary;
        border: none;
        outline: none;
      }
      // &:after {
      // 	border-color:#fff;
      // }
    }
    a.is-small {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// VerifyEmail.vue?6d11c33b